import { gsap } from 'gsap'

// -----------------------------------------------------------------------------
// Addition animation — a "+1" that rises from an element and fades out.
//
// Fixed to the viewport and appended to <body>, outside the Swup container, so
// it is never clipped by the card it rose from and cleans itself up even if the
// page changes mid-flight. Decoration only (aria-hidden): what changed is told
// by the cart count. Look: .addition-animation (_components/_addition-animation.scss).
//
// After the "+1" on the Museum Helmond site (theme-modules/addition-animation.js).
// -----------------------------------------------------------------------------

const DEFAULTS = {
	text: '+1',
	duration: 1.2,
	distance: 40, // px it rises
	scale: 1.5,
}

export function showAddition(element, options = {}) {
	const { text, duration, distance, scale } = { ...DEFAULTS, ...options }
	const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

	const el = document.createElement('span')
	el.className = 'addition-animation'
	el.setAttribute('aria-hidden', 'true')
	el.textContent = text

	// Measured hidden first, so it can be centred on the element.
	el.style.visibility = 'hidden'
	document.body.appendChild(el)

	const rect = element.getBoundingClientRect()
	const own = el.getBoundingClientRect()

	gsap.set(el, {
		left: rect.left + rect.width / 2 - own.width / 2,
		top: rect.top + rect.height / 2 - own.height / 2,
		visibility: 'visible',
	})

	const timeline = gsap.timeline({ onComplete: () => el.remove() })

	if (reduceMotion) {
		// No movement: only a short fade where it appeared.
		timeline.fromTo(el, { autoAlpha: 1 }, { autoAlpha: 0, duration: duration / 2, delay: 0.3 })
		return timeline
	}

	timeline
		.to(el, { y: -distance, duration, ease: 'power4.out', force3D: true }, 0)
		.fromTo(el, { scale: 1 }, { scale, duration, ease: 'power2.out', force3D: true }, 0)
		// Holds for the first stretch of the rise, then fades.
		.to(el, { opacity: 0, duration: duration * 0.6, ease: 'power1.in' }, duration * 0.1)

	return timeline
}
